import { render } from "./RespiratoryPanelTestSelection.vue?vue&type=template&id=e4d8fa8a"
import script from "./RespiratoryPanelTestSelection.vue?vue&type=script&lang=js"
export * from "./RespiratoryPanelTestSelection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/panels/testSelection/RespiratoryPanelTestSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4d8fa8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4d8fa8a', __exports__)) {
    console.log('reload')
    api.reload('e4d8fa8a', __exports__)
  }
  
  module.hot.accept("./RespiratoryPanelTestSelection.vue?vue&type=template&id=e4d8fa8a", () => {
    console.log('re-render')
    api.rerender('e4d8fa8a', render)
  })

}


export default __exports__